import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-carousel" }
const _hoisted_2 = { class: "message-carousel__controls" }
const _hoisted_3 = ["onClick"]

import CarouselSlide from '@/components/export/CarouselSlide.vue'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageCarousel',
  props: {
    triggerResetTimer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  triggerResetTimer: boolean
};



const slides = [
  {
    header: 'SERATO STUDIO',
    subheader: 'Sounds',
    body: 'Looking to take your beats to the next level? Then you need Serato\'s high-quality sound pack library. ' +
      'With thousands of royalty-free samples from world-renowned producers and musicians, you can add new layers or flair to your tracks. ' +
      'Simply visit <a href="' + process.env.VUE_APP_CLIENT_URI_SERATO_COM + '/studio/sounds" target="_blank">https://serato.com/studio/sounds</a> to start downloading for free.',
    smallImageFile: 'slide-one-700px-700px',
    bigImageFile: 'slide-one-900px-900px'
  },
  {
    header: 'GROW YOUR FOLLOWING',
    subheader: 'Build your brand',
    body: 'Make your videos recognisable at a glance by uploading your logo and using similar colours, filters and fonts.',
    smallImageFile: 'slide-three-700px-700px',
    bigImageFile: 'slide-three-900px-900px'
  },
  {
    header: 'TIPS AND TRICKS',
    subheader: 'Make your video pop',
    body: 'If you want your video to really stand out, try adding some effects that react to your beats. You can add an effect to individual layers for a unique look.',
    smallImageFile: 'slide-four-700px-700px',
    bigImageFile: 'slide-four-900px-900px'
  },
  {
    header: 'TIPS AND TRICKS',
    subheader: 'Get the size right <Get it right, get it tight>',
    body: 'Make sure you\'re using the correct aspect ratio for the platform you\'re posting to. Use the canvas shape toggle to export your video in different aspect ratios. That way, you\'ll make use of every pixel.',
    smallImageFile: 'slide-five-700px-700px',
    bigImageFile: 'slide-five-900px-900px'
  },
  {
    header: 'GROW YOUR FOLLOWING',
    subheader: 'Consistency is key',
    body: 'To build a fan base and get the greatest reach for your music and videos, aim to post new content every day.',
    smallImageFile: 'slide-six-700px-700px',
    bigImageFile: 'slide-six-900px-900px'
  },
  {
    header: 'TIPS AND TRICKS',
    subheader: 'Help us make the Visualizer even better',
    body: 'We want to make Visualizer the best it can be, and we need your help. If you have any suggestions for features or improvements, please submit them to us in the Serato forum. We love hearing your ideas!',
    smallImageFile: 'slide-seven-700px-700px',
    bigImageFile: 'slide-seven-900px-900px'
  }
]

const slideIndex = ref(0)
const slideDurationMilliseconds = 12000
let slideTimeout: ReturnType<typeof setTimeout>

const selectSlide = (index: number) => {
  restartSlideTimer()
  slideIndex.value = index
}

const incrementSlide = () => {
  if (slideIndex.value < slides.length - 1) {
    slideIndex.value++
  } else {
    slideIndex.value = 0
  }
  restartSlideTimer()
}

const restartSlideTimer = () => {
  clearTimeout(slideTimeout)
  slideTimeout = setTimeout(incrementSlide, slideDurationMilliseconds)
}

watch(() => props.triggerResetTimer, () => {
  slideIndex.value = 0
  restartSlideTimer()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide, index) => {
      return _createVNode(CarouselSlide, {
        key: index,
        header: slide.header,
        subheader: slide.subheader,
        body: slide.body,
        smallImageFile: slide.smallImageFile,
        bigImageFile: slide.bigImageFile,
        class: _normalizeClass(['message-carousel__slide', { 'message-carousel__slide--active': index === slideIndex.value }])
      }, null, 8, ["header", "subheader", "body", "smallImageFile", "bigImageFile", "class"])
    }), 64)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide, index) => {
        return _createElementVNode("span", {
          key: index,
          class: _normalizeClass(['message-carousel__circle', {'message-carousel__circle--active': index === slideIndex.value}]),
          onClick: ($event: any) => (selectSlide(index))
        }, null, 10, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})